export default {
  /**
   * Creates a copy of a playlist, starting from the current video.
   * @param {array} playlist
   * @param {number} item
   * @param {number} category
   * @returns {array}
   */
  preparePlaylist (playlist, item, playBackwards) {
    // if category 0 then plays in reverse
    return playBackwards ? playlist.slice(0, item + 1) : playlist.slice(item)
  },

  /**
   * DVR is weird and plays backwards so this is a way to control the playback order of a playlist
   * @param {array} playlist
   * @param {number} category
   * @returns {array}
   */
  preparePlayback (playlist, playBackwards) {
    let playback = []
    playlist.slice().forEach((v, k) => {
      playback.push(k)
    })
    // if category 0 then plays in reverse
    return playBackwards ? playback.reverse() : playback
  },

  /**
   * Gets category and item indexes relative to playlists from the slug.
   * @param {?string} slug
   * @returns {array}
   */
  getCategoryAndItemIndexes (playlists, slug = null, tray = null) {
    let item = null

    if (slug === null) {
      return item
    }

    for (let c in playlists) {
      for (let i in playlists[c].items) {
        if (typeof playlists[c].items[i].StorySlug !== 'undefined') {
          if (playlists[c].items[i].StorySlug === slug) {
            if (tray && tray !== playlists[c].category) {
              continue
            }
            return [parseInt(c), parseInt(i)]
          }
        }
      }
    }
    return item
  },

  /**
   * Returns an endpoint object
   */
  prepareEndpointObject (playlists, url = null, time = null) {
    return {
      url: url,
      time: time,
      interval: null,
      intervalSetting: null,
      playlists: playlists
    }
  }
}
